module.exports = __webpack_public_path__ + "static/media/employerpageimage.4522d3ac.png";